/**
 * Registers the slice's translations into the shared "resources" namespace.
 *
 * The dropdown's copy used to live under `actionPlans.visualization.*`, which a
 * questionnaire surface has no business reading — hence its own namespace now
 * that both apps' autodiagnostic renders it too.
 */
import i18n from "@/lib/i18n/i18n";

import { resourcesEn } from "./locales/en";
import { resourcesFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { resources: resourcesFr }, true, true);
i18n.addResourceBundle("en", "translation", { resources: resourcesEn }, true, true);
